import type { NextRouter } from "next/router"

import { debugEnabled } from "@/lib/routing/debugEnabled"
import type { Validation } from "@/lib/validation"
import { isString } from "@/lib/validation/isString"

export const getQueryParam = <ExpectedType = string>({
  isValid = isString as Validation.Functions.IsValid<ExpectedType>,
  key,
  router,
  warnOnFailure = true,
}: {
  isValid?: Validation.Functions.IsValid<ExpectedType>
  key: string
  router: NextRouter
  warnOnFailure?: boolean
}): ExpectedType | undefined => {
  const { [key]: value } = router.query

  if (!isValid(value)) {
    if (warnOnFailure && debugEnabled(router)) {
      console.log(`getQueryParam validation failure:`, { key, value, router })
    }
    return
  }

  return value
}
